import { createRoot } from "react-dom/client";
import { Toaster } from "sonner";
import "./index.css";
import AdminApp from "./AdminApp";

createRoot(document.getElementById("admin-root")!).render(
  <>
    <AdminApp />
    <Toaster />
  </>,
);
